module.exports = __webpack_public_path__ + "img/GreekTechPeltast3_ua.ad6f659c.webp";